import React from "react";
import * as S from "../styles";

const ImageModal = ({
  showAddImageModal,
  setShowAddImageModal,
  uploadingImage,
  fileInputRef,
  handleUploadFile,
  replacingImageId,
  setReplacingImageId,
  uploadingReplace,
  replaceFileInputRef,
  handleReplaceFileSelect,
  replacingOriginal,
  setReplacingOriginal,
  uploadingOriginal,
  originalFileInputRef,
  handleOriginalFileSelect,
}) => {
  return (
    <>
      {/* Add Image Modal */}
      {showAddImageModal && (
        <S.ModalOverlay onClick={() => setShowAddImageModal(false)}>
          <S.Modal onClick={(e) => e.stopPropagation()}>
            <S.ModalTitle>Добавить изображение</S.ModalTitle>
            <S.OptionButton onClick={() => fileInputRef.current?.click()}>
              📁 Загрузить файл
            </S.OptionButton>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleUploadFile}
            />

            {uploadingImage && <S.Loading>Загрузка...</S.Loading>}

            <S.ModalActions>
              <S.CancelButton onClick={() => setShowAddImageModal(false)}>
                Отменить
              </S.CancelButton>
            </S.ModalActions>
          </S.Modal>
        </S.ModalOverlay>
      )}

      {/* Replace Image Modal */}
      {replacingImageId !== null && (
        <S.ModalOverlay onClick={() => setReplacingImageId(null)}>
          <S.Modal onClick={(e) => e.stopPropagation()}>
            <S.ModalTitle>Заменить изображение</S.ModalTitle>
            <S.OptionButton
              onClick={() => replaceFileInputRef.current?.click()}
            >
              📁 Выбрать новый файл
            </S.OptionButton>
            <input
              ref={replaceFileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleReplaceFileSelect}
            />
            {uploadingReplace && <S.Loading>Загрузка...</S.Loading>}
            <p style={{ fontSize: "13px", color: "#888", marginTop: "10px" }}>
              Старый файл будет удалён, связи останутся прежними.
            </p>
            <S.ModalActions>
              <S.CancelButton onClick={() => setReplacingImageId(null)}>
                Отмена
              </S.CancelButton>
            </S.ModalActions>
          </S.Modal>
        </S.ModalOverlay>
      )}

      {/* Replace Block Original Modal */}
      {replacingOriginal && (
        <S.ModalOverlay onClick={() => setReplacingOriginal(false)}>
          <S.Modal onClick={(e) => e.stopPropagation()}>
            <S.ModalTitle>Заменить оригинальное изображение</S.ModalTitle>
            <S.OptionButton
              onClick={() => originalFileInputRef.current?.click()}
            >
              📁 Выбрать новый файл
            </S.OptionButton>
            <input
              ref={originalFileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleOriginalFileSelect}
            />
            {uploadingOriginal && <S.Loading>Загрузка...</S.Loading>}
            <p style={{ fontSize: "13px", color: "#888", marginTop: "10px" }}>
              Старый файл будет удалён.
            </p>
            <S.ModalActions>
              <S.CancelButton onClick={() => setReplacingOriginal(false)}>
                Отмена
              </S.CancelButton>
            </S.ModalActions>
          </S.Modal>
        </S.ModalOverlay>
      )}
    </>
  );
};

export default ImageModal;
